import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks } from "../content";
import ThemeToggle from "./ThemeToggle";

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const toggleRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => setMenuOpen(false), [pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        toggleRef.current?.focus();
      }
    };
    const closeOutside = (event) => {
      if (!navRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const desktop = window.matchMedia("(min-width: 1101px)");
    const closeOnDesktop = () => { if (desktop.matches) setMenuOpen(false); };
    document.addEventListener("keydown", closeOnEscape);
    document.addEventListener("pointerdown", closeOutside);
    desktop.addEventListener("change", closeOnDesktop);
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.removeEventListener("pointerdown", closeOutside);
      desktop.removeEventListener("change", closeOnDesktop);
    };
  }, [menuOpen]);

  return (
    <nav aria-label="Main navigation" ref={navRef}>
      <Link className="nav-logo" onClick={() => setMenuOpen(false)} to="/">
        <span className="nav-monogram" aria-hidden="true">rd.</span>
        <span className="nav-logo-text">Robert Doe<span className="nav-role">Research & engineering</span></span>
      </Link>
      <div className="nav-actions"><ThemeToggle/><button
        aria-controls="main-nav-links"
        aria-expanded={menuOpen}
        className="nav-toggle"
        onClick={() => setMenuOpen((open) => !open)}
        ref={toggleRef}
        type="button"
      >
        {menuOpen ? "Close" : "Menu"}
        <svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6">
          <path d={menuOpen ? "M6 6l12 12M6 18L18 6" : "M4 6h16M4 12h16M4 18h16"}/>
        </svg>
      </button></div>
      <ul className={`nav-links${menuOpen ? " is-open" : ""}`} id="main-nav-links">
        {navLinks.map((link) => (
          <li key={link.href}>
            <NavLink className={({ isActive }) => (isActive ? "active" : undefined)} onClick={() => setMenuOpen(false)} to={link.href}>
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
